import { render, staticRenderFns } from "./layout-body.vue?vue&type=template&id=117712fd"
import script from "./layout-body.vue?vue&type=script&lang=js"
export * from "./layout-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports